<template>
  <AuthBody/>
</template>

<script>
// @ is an alias to /src
import AuthBody from '@/components/AuthBody.vue'

export default {
  name: 'AuthView',
  components: {
    AuthBody
  }
}
</script>
